export default __webpack_public_path__ + "static/media/Clouds.a6d0b7d8.png";